import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { StepApi } from 'api';

export const findStep = createAsyncThunk(
  'step/findStep',
  async (option: Record<string, any>, { rejectWithValue }) => {
    try {
      const response = await StepApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStep = createAsyncThunk(
  'step/updateStep',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await StepApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkBeforeDeleteStep = createAsyncThunk(
  'step/checkBeforeDeleteStep',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await StepApi.checkBeforeDelete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteStep = createAsyncThunk(
  'step/deleteStep',
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await StepApi.delete(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

const stepSlice = createSlice({
  name: 'step',
  initialState: {
    tableList: [],
    list: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findStep.fulfilled, (state, action) => {
      const { data } = action.payload;

      const newData = data.map(item => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;
    });
  },
});

const { reducer: stepReducer } = stepSlice;

export default stepReducer;
